import { AvatarOnRubberRing } from 'components/referrals/2026/AvatarOnRubberRing';
import { PLAYER_FIRST_NAME_FALLBACK } from 'components/referrals/2026/ReferralConstants';
import { useMemo } from 'react';
import { getRandomMascotAvatar } from 'utils/dashboard/avatar';
import BeachBottomRight from '../../../../svg/refer-a-friend/BeachBottomRight.svg';
import Crab from '../../../../svg/refer-a-friend/Crab.svg';
import styles from './ReferAFriendBanner.module.css';

interface ReferAFriendBannerProps {
  referrerFirstName: string | undefined | null;
  referrerAvatarLocation: string | undefined;
}

const ReferAFriendBanner = (props: ReferAFriendBannerProps) => {
  const randomfriendAvatar = useMemo(() => getRandomMascotAvatar(), []);

  if (props.referrerFirstName == undefined) {
    return null;
  }

  return (
    <div className={styles.outerContainer}>
      <div className={styles.innerContainer}>
        <div className={'withNoSpacing ' + styles.container}>
          <div className={styles.referrerImage}>
            <AvatarOnRubberRing
              avatarUrl={props.referrerAvatarLocation || randomfriendAvatar}
            />
          </div>
          <div className={styles.textContainer}>
            <p className="aboutUsTypographyCaption">
              <strong className="aboutUsTypographyBodySmall">
                {props.referrerFirstName || PLAYER_FIRST_NAME_FALLBACK} invited
                you to play!
              </strong>
              <br />
              Join now for 50% off your first 4 weeks. When either of you wins,
              the other wins up to £5k
            </p>
          </div>
        </div>
        <BeachBottomRight className={styles.beachBottomRight} />
        <Crab className={styles.crab} />
      </div>
    </div>
  );
};

export default ReferAFriendBanner;
